import React from "react";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import { withStyles, makeStyles, Theme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ProductCardBig from "../productCard/ProductCardBig";

const DialogContent = withStyles((theme) => ({
  root: {
    height: "393px",
    width: "100%",
    padding: theme.spacing(0),
    "&:first-child": {
      paddingTop: 0,
    },
  },
}))(MuiDialogContent);

const useStyles = makeStyles((theme: Theme) => ({
  actionBar: {
    padding: theme.spacing(1, 2, 2),
    backgroundColor: theme.palette.background.default,
  },
}));

interface ItemDescriptionDialogProps {
  item: any | null;
  onClose: () => void;
  showButton?: boolean;
  showPrice?: boolean;
  hasDietaryOrAllergenRestrictions?: boolean;
  onClick?: () => void;
  onSelect?: () => void;
  buttonLabel?: string;
}

export default function ItemDescriptionDialog({
  item,
  onClose,
  showButton = false,
  showPrice = false,
  hasDietaryOrAllergenRestrictions,
  onClick,
  onSelect,
  buttonLabel = "LO VOGLIO",
}: ItemDescriptionDialogProps) {
  const fullScreen = useMediaQuery("(max-width:599px)");
  const classes = useStyles();

  if (!item) return null;

  return (
    <Dialog fullScreen={fullScreen} fullWidth onClose={onClose} open={true}>
      <DialogContent>
        <ProductCardBig
          item={item}
          showButton={onSelect ? false : showButton}
          showPrice={showPrice}
          hasDietaryOrAllergenRestrictions={hasDietaryOrAllergenRestrictions}
          onClick={onClick}
          onClose={onClose}
        />
      </DialogContent>
      {onSelect && (
        <div className={classes.actionBar}>
          <Button fullWidth color="primary" variant="contained" onClick={onSelect}>
            {buttonLabel}
          </Button>
        </div>
      )}
    </Dialog>
  );
}
